import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

export function getMultiMacroQueryBlocklistFF() {
	const blocklist = StatsigConfigurations.getStringList(
		'confluence_frontend_macros_query_blocklist',
		[
			'include',
			'jirachart',
			'jiraroadmap',
			'ui-button',
			'contentbylabel',
			'excerpt-include',
			'tasks-report-macro',
			'blog-posts',
			'section',
			'table-filter',
			'children',
			'pagetree',
			'detailssummary',
			'decisionreport',
		],
	);

	return String(blocklist).split(',');
}

export function getMultiMacrosQueryFF(featureFlags: Record<string, any> | undefined) {
	return Boolean(featureFlags?.['confluence.frontend.use-multiple-macros-query']);
}

export function canUseMultiMacroQuery(
	extensionKey: string | undefined,
	featureFlags: Record<string, any>,
) {
	return (
		getMultiMacrosQueryFF(featureFlags) &&
		!getMultiMacroQueryBlocklistFF().includes(extensionKey || '')
	);
}
